import React from "react";
import fp from "lodash/fp";
import SearchQueryParams from "./SearchQueryParams";
import { SearchQueryParamsConsumer } from "./SearchQueryParamsContext";

const withSearchQueryParamsContext = (options) => {
    return (WrappedComponent) => {
        const WithComponent = (props) => {
            return (
                <SearchQueryParams
                    addedSchema={fp.get("addedSchema", options)}
                    removeExtraParams={fp.get("removeExtraParams", options)}
                >
                    {options.setProps ? (
                        <SearchQueryParamsConsumer>
                            {(values) => <WrappedComponent {...props} searchQueryParams={values} />}
                        </SearchQueryParamsConsumer>
                    ) : (
                        <WrappedComponent {...props} />
                    )}
                </SearchQueryParams>
            );
        };

        return WithComponent;
    };
};

export default withSearchQueryParamsContext;
